module.exports = __webpack_public_path__ + "b042fd9bedfea0ea73562eb6e3333f28.png";